import type { AppLoginMethods, LoginPageViewTypes } from 'app-constants';
import type { VisiblePageAttributes } from 'models';
import type { FC } from 'react';

import {
  IdCardView,
  LoginPage as SharedLoginPage,
  LoginViewContent,
  MagicLinkView,
  PendingView,
  PinConfirmationView,
} from './index';

interface LoginPageContentProps {
  pageViewType: LoginPageViewTypes;
  styles: {
    'magic-link-view-container'?: string;
    'pending-view-container'?: string;
    paragraph?: string;
    buttons?: string;
    form?: string;
  };
  // Context data
  onIdCardLoginCancel?: () => void;
  loginByIdCardProcessing?: boolean;
  setPageViewType: (type: LoginPageViewTypes) => void;
  smartIdChallengeId: string;
  mobileIdChallengeId: string;
  stopLoginPolling: () => void;
  selectedLoginMethod: AppLoginMethods;
  visiblePageAttributes: VisiblePageAttributes;
  loginButtons?: any[];
  isLoginFlowWithError: boolean;
  // Required for LoginView
  loginFormsMap: Record<string, FC<any>>;
  // Optional overrides
  showContactUs?: boolean;
  includeIdCardView?: boolean;
  headingTranslationKey?: string;
}

export const LoginPageContent = ({
  pageViewType,
  styles,
  onIdCardLoginCancel,
  loginByIdCardProcessing,
  setPageViewType,
  smartIdChallengeId,
  mobileIdChallengeId,
  stopLoginPolling,
  selectedLoginMethod,
  visiblePageAttributes,
  loginButtons,
  isLoginFlowWithError,
  loginFormsMap,
  showContactUs = true,
  includeIdCardView = true,
  headingTranslationKey,
}: LoginPageContentProps) => {
  return (
    <SharedLoginPage
      pageViewType={pageViewType}
      loginView={
        <LoginViewContent
          loginButtons={loginButtons}
          selectedLoginMethod={selectedLoginMethod}
          isLoginFlowWithError={isLoginFlowWithError}
          visiblePageAttributes={visiblePageAttributes}
          loginFormsMap={loginFormsMap}
          styles={styles}
          headingTranslationKey={headingTranslationKey}
        />
      }
      pinConfirmationView={
        <PinConfirmationView
          smartIdChallengeId={smartIdChallengeId}
          mobileIdChallengeId={mobileIdChallengeId}
          stopLoginPolling={stopLoginPolling}
          selectedLoginMethod={selectedLoginMethod}
          visiblePageAttributes={visiblePageAttributes}
        />
      }
      idCardView={
        includeIdCardView ? (
          <IdCardView
            onCancel={onIdCardLoginCancel || (() => {})}
            isProcessing={!!loginByIdCardProcessing}
          />
        ) : undefined
      }
      magicLinkView={
        <MagicLinkView
          setPageViewType={setPageViewType}
          containerClassName={styles['magic-link-view-container']}
          paragraphClassName={styles.paragraph}
        />
      }
      pendingView={
        <PendingView
          containerClassName={styles['pending-view-container']}
          paragraphClassName={styles.paragraph}
        />
      }
      showContactUs={showContactUs}
    />
  );
};
